<template>
  <div class="sfboxl2">
    <div class="wfull">
        <ul class="hotfbox">
            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化镁A7">
                                                <img width="490" height="820" src="../../static/img/A7.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/A7.png 490w, ../../static/img/A7.png 768w, ../../static/img/A7.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化镁A7">氢氧化镁A7</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化镁 A7S">
                                                <img width="490" height="820" src="../../static/img/A7S.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/A7S.png 490w, ../../static/img/A7S.png 768w, ../../static/img/A7S.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化镁 A7S">氢氧化镁 A7S</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化镁  M17S">
                                                <img width="490" height="820" src="../../static/img/M17S.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/M17S.png 490w, ../../static/img/M17S.png 768w, ../../static/img/M17S.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化镁  M17S">氢氧化镁  M17S</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="无卤阻燃剂 FR516">
                                                <img width="490" height="820" src="../../static/img/FR516.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/FR516.png 490w, ../../static/img/B36.png 768w, ../../static/img/FR516.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="无卤阻燃剂 FR516">无卤阻燃剂 FR516</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="抑烟成碳剂 B36">
                                                <img width="490" height="820" src="../../static/img/B36.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/B36.png 490w, ../../static/img/B36.png 768w, ../../static/img/B36.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="抑烟成碳剂 B36">抑烟成碳剂 B36</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化铝 KH-101">
                                                <img width="490" height="820" src="../../static/img/KH-101.jpg" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/KH-101.jpg 490w, ../../static/img/KH-101.jpg 768w, ../../static/img/KH-101.jpg 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝 KH-101">氢氧化铝 KH-101</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化铝 KH-101LC">
                                                <img width="490" height="820" src="../../static/img/KH-101LC.jpg" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/KH-101LC.jpg 490w, ../../static/img/101LC001.png 768w, ../../static/img/KH-101LC.jpg 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝 KH-101LC">氢氧化铝 KH-101LC</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="粉末丁腈橡胶">
                                                <img width="490" height="820" src="../../static/img/粉末丁腈.jpg" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/粉末丁腈.jpg 490w, ../../static/img/qing.png 768w, ../../static/img/粉末丁腈.jpg 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="粉末丁腈橡胶">粉末丁腈橡胶</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">丁腈橡胶</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="硅酮">
                                                <img width="490" height="820" src="../../static/img/硅硐.jpg" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/硅硐.jpg 490w, ../../static/img/gui.png 768w, ../../static/img/硅硐.jpg 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="硅酮">硅酮</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">加工剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="抗氧剂">
                                                <img width="490" height="820" src="../../static/img/抗氧剂.jpg" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/抗氧剂.jpg 490w, ../../static/img/yang.png 768w, ../../static/img/抗氧剂.jpg 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="抗氧剂">抗氧剂</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">加工剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="增白剂">
                                                <img width="490" height="820" src="../../static/img/增白剂.jpg" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/增白剂.jpg 490w, ../../static/img/bai.png 768w, ../../static/img/增白剂.jpg 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="增白剂">增白剂</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">加工剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="钛白粉">
                                                <img width="490" height="820" src="../../static/img/钛白粉.jpg" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/钛白粉.jpg 490w, ../../static/img/tai.png 768w, ../../static/img/钛白粉.jpg 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="KH-101LC">钛白粉</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">加工剂</a></span>                
                </div>
            </li>

            <div class="clear"></div>
        </ul>
    </div>

    <div class="posts-nav wfull"></div>
    <div class="clear"></div>
</div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>




// WEBPACK FOOTER //
// Index.vue?41b48c8e